import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, Users, Wallet, Landmark, FileText, User } from "lucide-react";

const nav = [
  { to: "/institute", label: "Dashboard", icon: LayoutDashboard },
  { to: "/institute/students", label: "Students", icon: Users },
  { to: "/institute/commissions", label: "Commissions", icon: Wallet },
  { to: "/institute/bank", label: "Bank & Withdrawals", icon: Landmark },
  { to: "/institute-franchise/apply", label: "Application", icon: FileText },
  { to: "/learner/profile", label: "Profile", icon: User },
];

export default function InstituteLayout() {
  return <DashboardLayout nav={nav} title="Institute Partner" />;
}
